
import { CheckBoxButton } from "@goodgamestudios/asset-globals";
import { BasicModel } from "@goodgamestudios/core";
import { Timer } from "@goodgamestudios/createjs-utilities";
import { TextField } from "@goodgamestudios/createjs-utilities";
import { int } from "@goodgamestudios/math-utilities";
import { SFConstants } from "../../../constants/SFConstants";
import { Balancing } from "../../../constants/shared/Balancing";
import { Poker2BanditEvent } from "../../../event/Poker2BanditEvent";
import { Poker2SliderEvent } from "../../../event/Poker2SliderEvent";
import { BanditResultVO } from "../../../gamevo/BanditResultVO";
import { Poker2Model } from "../../../model/Poker2Model";
import { Poker2BanditRad } from "../../components/bandit/Poker2BanditRad";
import { Poker2BanditSterne } from "../../components/bandit/Poker2BanditSterne";
import { Poker2BanditWinnAnimation } from "../../components/bandit/Poker2BanditWinnAnimation";
import { Poker2Dialog } from "../Poker2Dialog";

import { NumberStringHelper } from "../../../helper/NumberStringHelper";

import Container = createjs.Container;
import Event = createjs.Event;
import MouseEvent = createjs.MouseEvent;
import TimerEvent = createjs.TimerEvent;

export class Poker2BanditDialog extends Poker2Dialog {
    public static NAME: string = "Poker2BanditDialog";

    private TXT_JACKPOT_TITEL: string = "dialog_slotmachine_jackpot";	// JACKPOT
    private TXT_JACKPOT: string = "dialog_slotmachine_infobox_jackpot";	// JACKPOT! {0}
    private TXT_LOST: string = "dialog_slotmachine_infobox_loose"; // Leider verloren...versuch es nochmal!
    private TXT_START: string = "dialog_slotmachine_infobox_start"; // Viel Glück!
    private TXT_WELCOME: string = "dialog_slotmachine_infobox_welcome"; // Hallo {0}!
    private TXT_WINN: string = "dialog_slotmachine_infobox_win"; // Gewonnen! {0}
    private TXT_INFO: string = "dialog_slotmachine_payoutTable"; // Gewinntabelle
    private TXT_USE: string = "dialog_slotmachine_stake"; // Einsatz
    private TXT_ERR: string = "dialog_slotmachine_locked"; // Kein Zutritt, erst ab Level 3!

    private TXT_I_WAIT4PLAY: string = "dialog_slotmachine_infobox_stake"; // Wähle deinen Einsatz...
    //		private const TXT_I_WAIT4PLAY:String = "dialog_slotmachine_infobox_bet"; // Wähle deinen Einsatz...

    private WAIT4PLAY_DELAY: number = 5000;	// spieler spielt nicht, dann TXT_I_WAIT4PLAY zeigen

    private EINSATZ_CASH_DEF: number = .1;
    private EINSATZ_GOLD_DEF: number = 1;
    private FACTOR_JACKPOT_MAX: number = 100;

    private RAD_ANZAHL: number = 3;
    private GAME_OVER: number = 0;	// melde dem server, spielanimation ist beendet, jetzt gewinn/verlust anzeigen
    private GAME_OVER_CLOSE: number = 1;	// melde dem server, spielende, durch vorzeitiges schliessen des fensters.

    private PLAYMODE_CASH: string = "play_cash";
    private PLAYMODE_GOLD: string = "play_gold";

    private LASVEGAS_DELAY: number = 600;	//	rahmen blinken

    private banditResultVO: BanditResultVO;
    private selectedPlayMode: string;
    private einsatzCash: number = NaN;
    private einsatzGold: number = NaN;
    private slots: Poker2BanditRad[];
    private sterne: Poker2BanditSterne[];
    private sliderMin: number = NaN;
    private sliderMax: number = NaN;
    private slider: SliderHelperStepper;
    private poker2BanditWinnAnimation: Poker2BanditWinnAnimation;
    private rotationAnimationFinNo: number = 0;
    private lasVegasTimer: Timer; // für lichteffekte usw.
    private wait4playTimer: Timer;

    constructor(disp: Container) {
        CONSTRUCTOR_HACK;
        super(disp);
    }

    /**
     * alles deinstallieren
     */
    public destroy(): void {
        if (this.slots) {
            this.slots[0].destroy();
            this.slots[1].destroy();
            this.slots[2].destroy();
            delete this.slots[0];
            delete this.slots[1];
            delete this.slots[2];
            this.slots = null;
        }
        if (this.sterne) {
            this.sterne[0].destroy();
            this.sterne[1].destroy();
            this.sterne[2].destroy();
            delete this.sterne[0];
            delete this.sterne[1];
            delete this.sterne[2];
            this.sterne = null;
        }
        this.poker2BanditWinnAnimation.destroy();
        this.banditDialog.mc_input.inputField.removeEventListener(Event.CHANGE, this.bindFunction(this.onChangeEinsatz));
        this.controller.removeEventListener("startBandit", this.bindFunction(this.onStartSlotmachine));
        this.controller.removeEventListener("hidePoker2NoMoneyDialog", this.bindFunction(this.onHideNoMoney));
        this.optikLasVegasStop();
        super.destroy();
    }

    /**
     *
     */
    protected init(): void {
        var radNo: number = 0;

        super.init();
        this.initTextFields();

        // init die drei stern-animationen
        if (!this.sterne) {
            this.sterne = [];
            for (radNo = 0; radNo < this.RAD_ANZAHL; radNo++) {
                this.sterne.push(new Poker2BanditSterne(this.banditDialog["Sterne" + (radNo + 1)], radNo));
            }
        }
        // init die drei räder
        if (!this.slots) {
            this.slots = [];
            for (radNo = 0; radNo < this.RAD_ANZAHL; radNo++) {
                this.slots.push(new Poker2BanditRad(this.banditDialog["Rad" + (radNo + 1)], radNo, this.bindFunction(this.meldeFertigGedreht)));
            }
        }
        this.banditDialog.mc_item_cash_gold_top.visible = false;
        this.poker2BanditWinnAnimation = new Poker2BanditWinnAnimation(this.banditDialog.mc_winn_animation_kreise);
        this.banditDialog.mc_Linien_Blinkanimation.mouseEnabled = false;
    }

    private initTextFields(): void {
        var userName: string = Poker2Model.userData.userName;

        this.banditDialog.txt_welcome.text = Poker2Model.languageData.getTextById(this.TXT_WELCOME, [userName]);
        this.banditDialog.mc_item_cash_gold_top.visible = false;
        this.banditDialog.txt_einsatz.text = Poker2Model.languageData.getTextById(this.TXT_USE);
        this.banditDialog.txt_jackpot.text = Poker2Model.languageData.getTextById(this.TXT_JACKPOT_TITEL);
        this.banditDialog.txt_gewinntabelle.text = Poker2Model.languageData.getTextById(this.TXT_INFO);
        this.banditDialog.mc_BanditAlertLevel.txt_err.text = Poker2Model.languageData.getTextById(this.TXT_ERR, [3]);
        this.banditDialog.txt_welcome.mouseEnabled = false;
        this.banditDialog.txt_einsatz.mouseEnabled = false;
        this.banditDialog.txt_jackpot.mouseEnabled = false;
        this.banditDialog.txt_gewinntabelle.mouseEnabled = false;
        this.banditDialog.mc_BanditAlertLevel.txt_err.mouseEnabled = false;
        //
        this.banditDialog.mc_input.inputField.restrict = "0-9";
        this.banditDialog.mc_input.inputField.maxChars = 8;	//	12.345.789
        // tooltipps
        this.banditDialog.check_tabcash.toolTipText = Poker2Model.languageData.getTextById("menu_chips_tooltip");
        this.banditDialog.check_tabgold.toolTipText = Poker2Model.languageData.getTextById("menu_gold_tooltip");
        this.banditDialog.btn_go.toolTipText = Poker2Model.languageData.getTextById("generic_login_playnow");
    }

    /**
     * ADDED_TO_STAGE
     */
    protected applyProperties(): void {
        // init eingabe, slider
        this.selectedPlayMode = this.PLAYMODE_CASH;
        this.einsatzCash = Math.floor(Poker2Model.userData.userCash * this.EINSATZ_CASH_DEF);
        this.einsatzGold = this.EINSATZ_GOLD_DEF;
        this.banditDialog.mc_input.inputField.addEventListener(Event.CHANGE, this.bindFunction(this.onChangeEinsatz));
        this.slider = new SliderHelperStepper(this.banditDialog.mc_slider);
        this.banditDialog.mc_slider.addEventListener("onSliding", this.bindFunction(this.onSliding));
        this.banditDialog.mc_slider.addEventListener("slideUp", this.bindFunction(this.onSliding));
        this.banditDialog.mc_slider.addEventListener("slideDown", this.bindFunction(this.onSliding));
        // für bestätigung vom server
        this.controller.addEventListener("startBandit", this.bindFunction(this.onStartSlotmachine));
        //
        this.controller.addEventListener("hidePoker2NoMoneyDialog", this.bindFunction(this.onHideNoMoney));
        //
        // optik
        // blinkende linien
        this.lasVegasTimer = new Timer(this.LASVEGAS_DELAY, 0);
        this.optikLasVegasStop();
        this.wait4PlayTimerStop();
        this.wait4playTimer = new Timer(this.WAIT4PLAY_DELAY, 1);
        this.poker2BanditWinnAnimation.hide();
    }

    /**
     * fenster öffnen
     */
    public show(): void {
        var radNo: number = 0;

        super.show();
        // init die drei räder
        for (radNo = 0; radNo < this.RAD_ANZAHL; radNo++) {
            this.slots[radNo].init();
        }
        // init hilfe
        this.banditDialog.mc_gewinntabelle.visible = false;
        // init button
        this.onCheckCashGold();

        if (this.isPossibleBandit()) {
            // eingaben ermöglichen
            this.unLockDialog();
            this.banditDialog.mc_BanditAlertLevel.visible = false;
        }
        else {
            // eingaben nicht ermöglichen
            this.lockDialog();
            this.banditDialog.mc_BanditAlertLevel.visible = true;
        }
        this.optikLasVegasStart();
        this.wait4PlayTimerStart();
        this.banditDialog.mc_item_cash_gold_top.visible = false;

        var userName: string = (!this.env.loginIsKeyBased) ? Poker2Model.userData.userName : this.env.displayName.slice(0, this.env.maxUsernameLength);
        this.banditDialog.txt_welcome.text = Poker2Model.languageData.getTextById(this.TXT_WELCOME, [userName]);
    }

    /**
     * fenster schliessen
     */
    public hide(): void {
        if (this.banditDialog) {
            this.banditDialog.mc_slider.removeEventListener("onSliding", this.bindFunction(this.onSliding));
            this.banditDialog.mc_slider.removeEventListener("slideUp", this.bindFunction(this.onSliding));
            this.banditDialog.mc_slider.removeEventListener("slideDown", this.bindFunction(this.onSliding));
        }
        this.optikLasVegasStop();
        this.wait4PlayTimerStop();
        if (this.isLocked) {
            // vorzeitig fenster geschlossenm, gewinn/verlust wird dennoch berechnet
            this.rotationAnimationFinNo = this.RAD_ANZAHL;
            this.meldeFertigGedreht(this.GAME_OVER_CLOSE);
        }
        super.hide();
    }

    /**
     * optische spielereien: linien blinken
     */
    private eventLasVegasTimer(evt: TimerEvent): void {
        var frame: number = int(this.banditDialog.mc_Linien_Blinkanimation.currentFrame);
        this.banditDialog.mc_Linien_Blinkanimation.gotoAndStop(3 - frame);
    }
    private optikLasVegasStart(): void {
        this.lasVegasTimer.addEventListener(TimerEvent.TIMER, this.bindFunction(this.eventLasVegasTimer));
        this.lasVegasTimer.start();
    }
    private optikLasVegasStop(): void {
        if (this.lasVegasTimer) {
            this.lasVegasTimer.stop();
            this.banditDialog.mc_Linien_Blinkanimation.gotoAndStop(1);
            this.lasVegasTimer.removeEventListener(TimerEvent.TIMER, this.bindFunction(this.eventLasVegasTimer));
        }
    }

    /**
     * user reagiert nicht, text wechseln
     */
    private eventWait4PlayerTimer(evt: TimerEvent): void {
        this.wait4PlayTimerStop();
        this.banditDialog.txt_welcome.text = Poker2Model.languageData.getTextById(this.TXT_I_WAIT4PLAY);
        if(this.banditDialog.mc_item_cash_gold_top.visible){
            this.banditDialog.mc_item_cash_gold_top.x = this.banditDialog.txt_welcome.textWidth / 2 + 20;
        }
    }
    private wait4PlayTimerStart(): void {
        this.wait4playTimer.addEventListener(TimerEvent.TIMER, this.bindFunction(this.eventWait4PlayerTimer));
        this.wait4playTimer.start();
    }
    private wait4PlayTimerStop(): void {
        if (this.wait4playTimer) {
            this.wait4playTimer.stop();
            this.wait4playTimer.removeEventListener(TimerEvent.TIMER, this.bindFunction(this.eventWait4PlayerTimer));
        }
    }

    /**
     * klick auf button und info
     */
    protected onClick(event: MouseEvent): void {
        super.onClick(event);

        // clicks immer

        switch (event.target) {
            // fenster schliessen
            case this.banditDialog.btn_close:
                this.hide();
                return;

            // information zeigen
            case this.banditDialog.btn_gewinntabelle:
            case this.banditDialog.mc_gewinntabelle:
                this.banditDialog.mc_gewinntabelle.visible = !this.banditDialog.mc_gewinntabelle.visible;
                break;
        }

        if (event.target.name === "btn_close") {
            this.hide();
            return;
        }

        // clicks nur, wenn nicht spielt

        if (this.isLocked) {
            return;
        }

        switch (event.target) {
            // setze cash
            case this.banditDialog.check_tabcash:
                this.onCheckCash();
                break;
            // setze gold
            case this.banditDialog.check_tabgold:
                this.onCheckGold();
                break;
            // spiele
            case this.banditDialog.btn_go:
                this.doGoPlay();
                break;
        }
    }

    /**
     * einsatz prüfen und anzeigen
     */
    private onCheckCashGold(): void {
        if (this.selectedPlayMode == this.PLAYMODE_CASH) {
            this.onCheckCash();
        }
        else {
            this.onCheckGold();
        }

    }

    /**
     * buttonklick: spiele um geld
     */
    private onCheckCash(): void {
        this.banditDialog.mc_item_cash_gold.gotoAndStop(1);
        ((this.banditDialog.check_tabcash) as CheckBoxButton).selected();
        ((this.banditDialog.check_tabgold) as CheckBoxButton).deselected();
        this.selectedPlayMode = this.PLAYMODE_CASH;
        this.calculateCash();
    }

    /**
     * buttonklick: spiele um gold
     */
    private onCheckGold(): void {
        this.banditDialog.mc_item_cash_gold.gotoAndStop(2);
        ((this.banditDialog.check_tabgold) as CheckBoxButton).selected();
        ((this.banditDialog.check_tabcash) as CheckBoxButton).deselected();
        this.selectedPlayMode = this.PLAYMODE_GOLD;
        this.calculateGold();
    }

    /**
     * sliderklick: mehr/ weniger
     */
    private onSliding(event: Poker2SliderEvent): void {
        var einsatz: number = NaN;

        if (event.type == "slideUp" || event.type == "slideDown") {
            // take stepwise values from SliderStepper component
            einsatz = Math.floor(event.numericValue);
        }
        else {
            // calulates stepless values
            einsatz = Math.floor(this.sliderMin + ((this.sliderMax - this.sliderMin) * event.percentValue / 100));
        }
        if (isNaN(einsatz)) {
            // bei z.b. 0/100
            einsatz = 0;
        }
        if (this.selectedPlayMode == this.PLAYMODE_CASH) {
            this.einsatzCash = einsatz;
            this.calculateCash();
        }
        else {
            this.einsatzGold = einsatz;
            this.calculateGold();
        }
    }
    /**
     * bei jeder texteingabe aktualisiere den slider + den jackpot
     * aber die eingabe nicht ändern .. das soll der go_btn machen
     */
    private onChangeEinsatz(event: Event): void {
        var eingabe: number = Math.floor(parseFloat(this.banditDialog.mc_input.inputField.text));
        if (isNaN(eingabe) || !eingabe) eingabe = 0;

        if (this.selectedPlayMode == this.PLAYMODE_CASH) {
            this.einsatzCash = eingabe;
            this.calculateCash(false);
        }
        else {
            this.einsatzGold = eingabe;
            this.calculateGold(false);
        }
        this.wait4PlayTimerStop();
    }

    /**
     * berechne und anzeige den möglichen einsatz in cash
     * @param korr		true: schreibe korrigierten wert in das textfeld, sonst nur prüfen
     * @return false	wenn der wert verändert wurde
     */
    private calculateCash(korr: boolean = true): boolean {
        var einsatz: number = this.einsatzCash;

        this.sliderMax = Math.floor(Poker2Model.userData.userCash * 0.2);
        this.sliderMin = Math.floor(Poker2Model.userData.userCash * 0.001);
        this.einsatzCash = (this.einsatzCash > this.sliderMax) ? this.sliderMax : (this.einsatzCash < this.sliderMin) ? this.sliderMin : this.einsatzCash;
        //
        if (korr) {
            this.banditDialog.mc_input.inputField.text = String(this.einsatzCash);
        }

        if (einsatz == this.einsatzCash || korr) {
            this.banditDialog.txt_maxwin.text = NumberStringHelper.groupString(Math.floor(this.einsatzCash * this.FACTOR_JACKPOT_MAX), Poker2Model.languageData.getTextById.bind(Poker2Model.languageData));
        }
        else {
            this.banditDialog.txt_maxwin.text = '';
        }

        this.slider.initSliderStepper(this.sliderMin, this.sliderMax, Math.floor((this.sliderMax - this.sliderMin) / 9) + 1, this.einsatzCash);

        return einsatz == this.einsatzCash;
    }

    /**
     * berechne und anzeige den möglichen einsatz in gold
     * @param korr		true: schreibe korrigierten wert in das textfeld, sonst nur prüfen
     * @return false	wenn der wert verändert wurde
     */
    private calculateGold(korr: boolean = true): boolean {
        var einsatz: number = this.einsatzGold;

        this.sliderMax = 100;
        this.sliderMin = 1;
        this.einsatzGold = (this.einsatzGold > this.sliderMax) ? this.sliderMax : (this.einsatzGold < this.sliderMin) ? this.sliderMin : this.einsatzGold;
        //
        if (korr) {
            this.banditDialog.mc_input.inputField.text = String(this.einsatzGold);
        }

        if (einsatz == this.einsatzGold || korr) {
            this.banditDialog.txt_maxwin.text = NumberStringHelper.groupString(Math.floor(this.einsatzGold * this.FACTOR_JACKPOT_MAX), Poker2Model.languageData.getTextById.bind(Poker2Model.languageData));
        }
        else {
            this.banditDialog.txt_maxwin.text = '';
        }

        this.slider.initSliderStepper(this.sliderMin, this.sliderMax, (this.sliderMax - this.sliderMin) / 10, this.einsatzGold);

        return einsatz == this.einsatzGold;
    }

    /**
     * buttonklick: spiel starten
     */
    private doGoPlay(): void {
        var obj: any;
        var einsatzOK: boolean = false;

        if (!this.isLocked) {
            var eingabe: number = Math.floor(parseFloat(this.banditDialog.mc_input.inputField.text));
            if (isNaN(eingabe) || !eingabe) eingabe = 0;

            if (this.selectedPlayMode == this.PLAYMODE_CASH) {
                this.einsatzCash = eingabe;
                einsatzOK = this.calculateCash();
            }
            else {
                this.einsatzGold = eingabe;
                einsatzOK = this.calculateGold();
            }

            if (einsatzOK) {
                this.banditDialog.btn_go.gotoAndStop(3);
                this.banditResultVO = new BanditResultVO();

                // zum testen, server übergehen
                // obj = {cashWon:1000, goldWon:0, slot1Icon:3, slot2Icon:3, slot3Icon:3};
                // controller.dispatchEvent(new Poker2BanditEvent("startBandit", [JSON.stringify(obj)]));

                this.lockDialog(); // HS1077

                obj = (this.selectedPlayMode == this.PLAYMODE_CASH) ? { cash: this.einsatzCash, gold: 0 } : { cash: 0, gold: this.einsatzGold };
                BasicModel.smartfoxClient.sendMessage("ssm", [JSON.stringify(obj)]);
            }
        }
    }

    /**
     * C2S_START_SLOTMACHINE doGoPlay -> hier kommt die antwort vom server zurück
     */
    private onStartSlotmachine(event: Poker2BanditEvent): void {
        // spiel buttons deaktivieren
        this.lockDialog();
        this.banditResultVO.parse_SSM(JSON.parse(event.params[0]));
        this.banditDialog.txt_welcome.text = Poker2Model.languageData.getTextById(this.TXT_START);
        this.banditDialog.mc_item_cash_gold_top.visible = false;

        // switch icon in header accordingly the played investment currency
        this.switchWonIconInHeader(this.banditResultVO);

        // räder starten
        this.rotationAnimationFinNo = 0;
        // slot1Icon ist -1, 1,2,3,4,5,6
        this.slots[0].startRotation(this.banditResultVO.slot1Icon);
        this.slots[1].startRotation(this.banditResultVO.slot2Icon);
        this.slots[2].startRotation(this.banditResultVO.slot3Icon);
        //
        // optik
        Poker2BanditSterne.allSterneStart(this.sterne);
        this.optikLasVegasStop();
        this.wait4PlayTimerStop();
    }

    // HS1203
    private onHideNoMoney(event: Poker2BanditEvent): void {
        this.unLockDialog();
    }

    private switchWonIconInHeader(banditResultVO: BanditResultVO): void {
        // check which currency has been played
        if (banditResultVO.cashWon > 0) {
            // game was played for chips
            this.banditDialog.mc_item_cash_gold_top.gotoAndStop(1);
        }
        else if (banditResultVO.goldWon > 0) {
            // game was played for gold
            this.banditDialog.mc_item_cash_gold_top.gotoAndStop(2);
        }
    }

    /**
     * gewinn/verlust anzeige
     */
    public meldeFertigGedreht(art: number = this.GAME_OVER): void {
        var obj: any;
        var winnSumme: number = NaN;

        if (this.banditResultVO) {
            this.rotationAnimationFinNo++;
            if (this.rotationAnimationFinNo >= this.RAD_ANZAHL) {
                // spiel buttons aktivieren
                this.unLockDialog();
                // optik
                Poker2BanditSterne.allSterneStopp(this.sterne);
                this.optikLasVegasStart();
                this.wait4PlayTimerStart();

                obj = { cur1: Poker2Model.userData.userCash, cur2: Poker2Model.userData.userGold };
                winnSumme = 0;

                if (this.banditResultVO.cashWon || this.banditResultVO.goldWon) {
                    // gewonnen
                    if (this.selectedPlayMode == this.PLAYMODE_CASH) {
                        winnSumme = this.banditResultVO.cashWon;
                        obj.cur1 += winnSumme - this.einsatzCash;
                    }
                    else {
                        winnSumme = this.banditResultVO.goldWon;
                        obj.cur2 += winnSumme - this.einsatzGold;
                    }
                    this.banditDialog.txt_welcome.text = Poker2Model.languageData.getTextById(this.TXT_WINN, [winnSumme]);
                    this.banditDialog.mc_item_cash_gold_top.visible = true;
                    this.banditDialog.mc_item_cash_gold_top.x = this.banditDialog.txt_welcome.textWidth / 2 + 20;
                }
                else {
                    // verlohren
                    if (this.selectedPlayMode == this.PLAYMODE_CASH) {
                        obj.cur1 -= this.einsatzCash;
                    }
                    else {
                        obj.cur2 -= this.einsatzGold;
                    }
                    this.banditDialog.txt_welcome.text = Poker2Model.languageData.getTextById(this.TXT_LOST);
                    this.banditDialog.mc_item_cash_gold_top.visible = false;
                }
                this.winnLostAnimation();

                /**
                 * achtung: simuliert S2C_GET_CURRENCY !!!
                 * der server berechent direkt
                 * anzeige hier zeitlich verzögert, nach dem spiel
                var gcu:GCUCommand = new GCUCommand();
                gcu.executeCommand(0,[0,JSON.stringify({gcu:obj})]);
                 */
                this.banditResultVO = null;
                // melde dem server spielende
                BasicModel.smartfoxClient.sendMessage("css", [JSON.stringify({ art: art })]);
            }
        }
    }

    /**
     *
     */
    private winnLostAnimation(): void {
        if ((this.banditResultVO.cashWon || this.banditResultVO.goldWon)
            && (this.banditResultVO.slot1Icon == this.banditResultVO.slot2Icon && this.banditResultVO.slot1Icon == this.banditResultVO.slot3Icon)) {
            // gewonnen - anzeige wenn alle drei räder gleich
            this.poker2BanditWinnAnimation.play();
        }
        else {
            // verlohren
            this.poker2BanditWinnAnimation.hide();
        }
    }

    /**
     * bedingungen um bandit spielen zu dürfen
     * @return true		wenn der level ausreichend ist
     */
    private isPossibleBandit(): boolean {
        return Poker2Model.userData.userLevel >= 3;
    }

    /**
     * play: keine eingabe
     */
    public lockDialog(): void {
        super.lockDialog();
        this.slider.enabled = false;
        ((this.banditDialog.mc_input.inputField) as TextField).mouseEnabled = false;
        this.banditDialog.btn_go.mouseEnabled = false;
    }

    /**
     * kein play: eingabe ermöglichen
     */
    public unLockDialog(): void {
        super.unLockDialog();
        this.slider.enabled = true;
        ((this.banditDialog.mc_input.inputField) as TextField).mouseEnabled = true;
        this.banditDialog.btn_go.mouseEnabled = true;
    }

    /**
     * get referenz auf das assets
     */
    protected get banditDialog(): Library.PokerBandit.PokerBandit {
        return this.disp as Library.PokerBandit.PokerBandit;
    }

    //
    // ende
    //
}
import { SliderHelperStepper } from "../../helper/SliderHelperStepper";
